import Axios from 'axios';

export const sendArrivedSMS = (orderId: string, to: string, msg: string) =>
  Axios.post(`${window.API_ENDPOINT}/SMs/send/arrived`, { orderId, to, msg });

export const sendSingleSMS = (to: string, msg: string) =>
  Axios.post(`${window.API_ENDPOINT}/SMs/send`, { to, msg });
